import React from 'react';
import styled, { keyframes } from 'styled-components';
import { CardContent, MainContent, SkeletonCard } from './styles';

const EventCardSkeleton: React.FC = () => {
    return (
        <SkeletonCard data-auto='event-card-skeleton'>
            <CardContent>
                <MainContent>
                    <TitleSkeleton />
                    <DescriptionSkeleton />
                    <DurationSkeleton />
                </MainContent>
                <PriceSkeleton />
            </CardContent>
        </SkeletonCard>
    );
};

const pulse = keyframes`
    50% {
        opacity: .5;
    }
`;

const SkeletonBase = styled.div`
    background: #e5e7eb;
    animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    border-radius: 6px;
`;

const TitleSkeleton = styled(SkeletonBase)`
    height: 20px;
    width: 70%;
`;

const PriceSkeleton = styled(SkeletonBase)`
    height: 20px;
    width: 50px;
    flex-shrink: 0;
    align-self: flex-start;
`;

const DescriptionSkeleton = styled(SkeletonBase)`
    height: 16px;
    width: 90%;
`;

const DurationSkeleton = styled(SkeletonBase)`
    height: 16px;
    width: 60px;
`;

export default EventCardSkeleton;
